import { toast } from 'react-toastify';
import { ToastContent } from 'react-toastify/dist/types';

const defaultOptions = {
	position: toast.POSITION.TOP_CENTER,
	autoClose: 6000,
	hideProgressBar: true,
	closeOnClick: true,
	pauseOnHover: true,
	draggable: true,
};

export const toastError = (message: string) => toast.error(message, defaultOptions);

export const persistentToastError = (message: string, onClickEvent = () => {}) =>
	toast.error(message, {
		...defaultOptions,
		draggable: false,
		autoClose: false,
		closeOnClick: false,
		closeButton: false,
		onClick: () => {
			onClickEvent();
			toast.dismiss();
		},
	});

export const persistentToastWarning = (message: ToastContent<unknown>, onClickEvent = () => {}) =>
	toast.warn(message, {
		toastId:'persistentToastWarning',
		...defaultOptions,
		draggable: false,
		autoClose: false,
		closeOnClick: false,
		closeButton: true,
		onClick: () => {
			onClickEvent();
		},
	});

export const toastWarning = (message: string) => toast.warning(message, defaultOptions);

export const toastSuccess = (message: string) => {
	toast.dismiss();
	toast.success(message, defaultOptions);
};
